export const pt = {
    invalidLinkTitle: `Link de redefinição inválido`,
    invalidLinkDescription: `Este link de redefinição é inválido ou expirou`,
    invalidToken: `Token de redefinição inválido ou ausente. Por favor solicite uma nova redefinição de senha.`,
    requestNewReset: `Solicitar nova redefinição`,
    title: `Redefinir senha`,
    description: `Digite sua nova senha para {email}`,
    success: `Senha redefinida com sucesso! Agora você pode entrar com sua nova senha.`,
    redirect: `Você será redirecionado para a página de login em {count} segundos...`,
    continueNow: `Continuar para entrar agora`,
    resetPasswordButton: `Redefinir senha`,
    failure: `Falha ao redefinir a senha. Por favor tente novamente.`,
};
//# sourceMappingURL=pt.js.map